export default __webpack_public_path__ + "static/media/3d.f822e495.svg";